import React, { Component } from 'react';
import { connect } from 'react-redux';
import { t } from 'ttag';
import Tabs from '../../components/detailTabs/desktopTabs/tabs';
import ProductSliderContainer from '../../../productSliders/index';
import * as galleryActions from '../../components/gallerySlider/galleryActions';
import * as appActions from '../../appActions';
import ErrorBoundary from '../../../ErrorBoundary';
import './belowFoldStyle.less';
import UserGeneratedContent from '../../../reusable-components/Ratings/UserGeneratedContent';
import Reviews from '../../../reusable-components/Ratings/Reviews';
import Questions from '../../../reusable-components/Ratings/Questions';
import ReviewsPrimary from '../../../reusable-components/Ratings/ReviewsPrimary';
import OrbitvuImage from '../../components/OrbitvuImage/OrbitvuImage';

class BelowFold extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const productClick = this.props.FETCH_AND_REPLACE_STATE;
    return (
      <div id="belowFold">
        <OrbitvuImage productId={this.props.product_id} />
        <ErrorBoundary location="productpage" errorComponent={null}>
          <Tabs />
        </ErrorBoundary>
        <ErrorBoundary location="productslider" errorComponent={null}>
          <ProductSliderContainer
            title={t`Alternative products`}
            algorithm="more-like-this"
            algorithmOptions={{
              product_id: this.props.product_id
            }}
            // addToCartForm
            productClick={productClick}
          />
        </ErrorBoundary>
        <ErrorBoundary location="productpage" errorComponent={null}>
          <UserGeneratedContent productID={this.props.product_id} />
        </ErrorBoundary>
        <Reviews>
          <ReviewsPrimary productID={this.props.product_id} />
        </Reviews>
        <Questions productID={this.props.product_id} />
        {/* <ErrorBoundary location="productslider" errorComponent={null}>
          <ProductSliderContainer
            title={t`Last seen`}
            algorithm="last-seen"
            algorithmOptions={{}}
            // addToCartForm
            productClick={productClick}
          />
        </ErrorBoundary> */}
      </div>
    );
  }
}

const mapStateToProps = ({ app }) => {
  return {
    product_id: app.data.product_id
  };
};

export default connect(mapStateToProps, { ...appActions, ...galleryActions })(
  BelowFold
);
